import { render, staticRenderFns } from "./ContingenciaData.vue?vue&type=template&id=24115473&"
import script from "./ContingenciaData.vue?vue&type=script&lang=js&"
export * from "./ContingenciaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports